import * as React from 'react'
import { object, func, bool, string, any } from 'prop-types'
import Modal from '@mui/material/Modal'
import { Close } from '@mui/icons-material'
import { Box, IconButton, styled } from '@mui/material'
const ModalTitle = styled(Box)(({ theme }) => ({
  background: theme.palette.leitura.main,
  // padding: title === '' ? '0rem' : '0.75rem 1rem',
  padding: '0.75rem 1rem',
  color: 'white',
  fontSize: '1.75rem',
  fontWeight: 'bold',
  borderRadius: '5px 5px 0px 0px',
  display: 'flex',
  justifyContent: 'space-between'
}))

export default function BasicModal({
  children,
  title = '',
  Caller,
  closeEvent,
  status,
  sx,
  canClose = true
}) {
  const [open, setOpen] = React.useState(status)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const [podeFechar, setPodeFechar] = React.useState(true)

  React.useEffect(() => {
    setPodeFechar(canClose)
  }, [canClose])

  const style = {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'auto',
    bgcolor: 'background.paper',
    border: 'none',
    borderRadius: '5px',
    boxShadow: 24,
    p: 0,
    maxHeight: '90vh'
  }

  React.useEffect(() => {
    setOpen(status)
  }, [status])

  React.useEffect(() => {
    closeEvent(open)
  }, [open])

  return (
    <div>
      <Caller onClick={handleOpen} />
      <Modal
        open={open}
        onClose={() => {
          if (podeFechar === true) handleClose()
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableEscapeKeyDown={true}
      >
        <Box sx={{ ...style, ...sx }}>
          <ModalTitle sx={{ padding: title === '' ? '0px' : '0.75rem 1rem' }}>
            {title}
            {title !== '' && (
              <IconButton
                onClick={() => {
                  if (podeFechar) handleClose()
                }}
              >
                <Close style={{ fill: 'white' }} />
              </IconButton>
            )}
          </ModalTitle>
          <Box sx={{ p: 2 }}>{children}</Box>
        </Box>
      </Modal>
    </div>
  )
}

BasicModal.propTypes = {
  title: string,
  children: any,
  Caller: func,
  closeEvent: func,
  status: bool,
  sx: object,
  canClose: bool
}
